import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { PageHeader } from '../../components/Shared';
import { FlyerDownloadSection } from '../../components/FlyerDownload';
import { CvDownloadSection } from '../../components/CvDownload';
import { fileUrl } from '../../lib/api';
import { setPageMeta } from '../../lib/seo';

// About > CV & Flyer: the two downloads, same files and download counters as everywhere else.
export default function CvFlyer() {
  useEffect(() => {
    setPageMeta({ title: "Steve's CV and Campaign Flyer | Downloads", description: 'Download Steve Lesperance\'s CV and the two page Ward 8 campaign flyer.', url: window.location.origin + '/about/cv-flyer' });
  }, []);
  return (
    <div data-testid="cv-flyer-page">
      <PageHeader pageKey="about-cv-flyer" kicker="DOWNLOADS" title="Steve's CV and Campaign Flyer" subtitle="The two page flyer and full CV, ready to download, print and share." image={fileUrl('/api/uploads/flyer-letter.png')} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 space-y-6">
        <section id="flyer" data-testid="cv-flyer-flyer-section"><FlyerDownloadSection loc="about-cv-flyer" /></section>
        <section id="cv" data-testid="cv-flyer-cv-section"><CvDownloadSection loc="about-cv-flyer" /></section>
        <div className="flex flex-wrap gap-3 pt-2">
          <Button asChild variant="outline" className="h-11 border-[#1a2744] text-[#1a2744] font-bold bg-white btn-press" data-testid="cv-flyer-back-about"><Link to="/about">Back to About</Link></Button>
          <Button asChild className="h-11 bg-[#1a2744] hover:bg-[#24406f] text-white font-bold btn-press" data-testid="cv-flyer-platform"><Link to="/platform">Read the Platform <ArrowRight className="h-4 w-4 ml-1" /></Link></Button>
        </div>
      </div>
    </div>
  );
}
